import React, { FC } from 'react'
import styled from 'styled-components'
import { LottieAnimation, LottieAnimationName } from '../lotties'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const Text = styled.span`
    color: ${(p) => p.theme.colors.lightGrey};
`

interface Props {
    name?: LottieAnimationName
    width?: string
    height?: string
    message?: string
    className?: string
}

export const Loading: FC<Props> = ({ message, name, className, ...props }) => {
    return (
        <Container className={className}>
            {name && <LottieAnimation name={name} {...props} />}
            {message && <Text>{message}</Text>}
        </Container>
    )
}
